/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_mode_c2j = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV to JSON`)
};

const es_cj_mode_c2j = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV a JSON`)
};

const de_cj_mode_c2j = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV zu JSON`)
};

const nl_cj_mode_c2j = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV naar JSON`)
};

const fr_cj_mode_c2j = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV en JSON`)
};

const it_cj_mode_c2j = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV a JSON`)
};

const pt_br2_cj_mode_c2j = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV para JSON`)
};

const pt_cj_mode_c2j = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV para JSON`)
};

const ja_cj_mode_c2j = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV から JSON へ`)
};

const zh_cj_mode_c2j = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 转 JSON`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_mode_c2j = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_mode_c2j(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_mode_c2j", locale)
	if (locale === "en") return en_cj_mode_c2j(inputs)
	if (locale === "es") return es_cj_mode_c2j(inputs)
	if (locale === "de") return de_cj_mode_c2j(inputs)
	if (locale === "nl") return nl_cj_mode_c2j(inputs)
	if (locale === "fr") return fr_cj_mode_c2j(inputs)
	if (locale === "it") return it_cj_mode_c2j(inputs)
	if (locale === "pt-BR") return pt_br2_cj_mode_c2j(inputs)
	if (locale === "pt") return pt_cj_mode_c2j(inputs)
	if (locale === "ja") return ja_cj_mode_c2j(inputs)
	return zh_cj_mode_c2j(inputs)
};